export const CHAR = {
  NBSP: '\u00A0',
  SP: '\u0020',
  NEW_LINE: '\u000A',
  MDASH: '\u2014',
};
